// extracted by mini-css-extract-plugin
export default {"root":"_2wHsq","scrollable":"f91YH","size-small":"IsHfC","sizeSmall":"IsHfC","size-medium":"_3Vvtx","sizeMedium":"_3Vvtx","tag-item":"oA9K5","tagItem":"oA9K5"};